module.exports = __webpack_public_path__ + "img/icon2.a220ea07.png";